import { ref, onMounted, watch } from 'vue'
import {
	getStatesList,
	getCityListByState,
	getCollegeListByDistrict,
	getDistricteListByState,
} from '../api'

export default function useCollegeSelect() {
	/** State Stuff */
	const stateOptions = ref([])
	const selectedState = ref(null)
	onMounted(async () => {
		const {data, status} = await getStatesList()
		if (data && data.length) {
			stateOptions.value = data.sort((a, b) => (a.name > b.name ? 1 : -1))
		}
	})

	/** City Stuff */
	// const cityOptions = ref([])
	// const selectedCity = ref(null)
	// const isCityOptionLoaded = ref(false)

	// const fetchCities = async (stateId) => {
	// 	if (!stateId) return
	// 	isCityOptionLoaded.value = false
	// 	selectedCity.value = null
	// 	const {data:cities} = await getCityListByState(stateId)
	// 	if (cities && cities.length) {
	// 		cityOptions.value = cities.sort((a, b) => (a.name > b.name ? 1 : -1))
	// 	}
	// 	isCityOptionLoaded.value = true
	// }
	// watch(selectedState, (stateId, oldStateId) => {
	// 	fetchCities(stateId)
	// })

	/** District Stuff */

	const districtOptions = ref([])
	const selectedDistrict = ref(null)
	const isDistrictOptionLoaded = ref(false)

	const fetchDistricts = async (stateId) => {
		if (!stateId) return
		isDistrictOptionLoaded.value = false
		selectedDistrict.value = null
		const {data:district} = await getDistricteListByState(stateId)
		if (district && district.length) {
			districtOptions.value = district.sort((a, b) => (a.name > b.name ? 1 : -1))
		}
		isDistrictOptionLoaded.value = true
	}
	watch(selectedState, (stateId, oldStateId) => {
		fetchDistricts(stateId)
	})

	/** College Stuff */
	const collegeOptions = ref([])
	const selectedCollege = ref(null)
	const isStateOptionLoaded = ref(false)

	const fetchColleges = async (districtId) => {
		if (!districtId) return
		isStateOptionLoaded.value = false
		selectedCollege.value = null
		const {data:colleges} = await getCollegeListByDistrict(districtId)
		if (colleges && colleges.length) {
			collegeOptions.value = colleges
				.sort((a, b) => (a.name > b.name ? 1 : -1))
				.map((college) => ({ label: college.name, value: college.id }))
		}
		isStateOptionLoaded.value = true
	}
	watch(selectedDistrict, (districtId, oldcityId) => fetchColleges(districtId))

	return {
		stateOptions,
		selectedState,
		// cityOptions,
		// selectedCity,
		districtOptions,
		selectedDistrict,
		collegeOptions,
		selectedCollege,
		// isCityOptionLoaded,
		isStateOptionLoaded,
		isDistrictOptionLoaded,
	}
}
